import PaperLayout from './PaperLayout.view';
export default PaperLayout;
